
import a1residential from '../assets/a1residential.png'
import prontocasecase from "../assets/pronto.png"
import waa from "../assets/waa.png"
import crm from "../assets/crm.png"
import PathFinder from "../assets/geo-location.png"
import Profile_Photo from "../assets/Raju_Profile_photo.gif"
import heroBg from "../assets/webdev.svg";
import cloud from "../assets/cloudBg.png";
import cloudDark from "../assets/cloudDark.png";
import iKidz from "../assets/ikidz.png";
import relaxNow from "../assets/relax-now.png"
import  pisteyo from "../assets/pisteyo.jpeg"
import monday from "../assets/monday.jpeg"
import ga from "../assets/ga.jpg"
import lovelife from "../assets/lovelife.jpg"
import sportsjournal from "../assets/sportsjournal.jpeg"
import TrendingNow from "../assets/TrendingNow.jpg"
import talktoenergy from "../assets/talktoenergy.jpeg"
import highcourt from "../assets/highcourt.jpeg"
import reliefhub from "../assets/reliefhub.jpg";
import hcba from "../assets/hcba.jpeg"
import skin_care from "../assets/skin-care-app.jpeg"
import swing from "../assets/swing-user.png"
import swingAdmin from "../assets/swing-admin.png"
import GaAdmin from "../assets/ga-admin.jpeg"
import WhatKeyAdmin from "../assets/what-key-admin.jpeg"
import ikidzschool from "../assets/ikidzschool.png";
import ikidz_smart_app from "../assets/ikidz_smart_app.jpg";
import hcba_app from "../assets/hcba_app.jpg";
import hcbaadvocate from "../assets/hcbaadvocate.png";
import rewind from "../assets/rewind.jpg";

import {calculateAgeInYears} from '../utills/calculateAgeInYears'
import { dob } from './common'

const shortIntro = `ਮੈਂ ਇੱਕ ਫਰੰਟ-ਐਂਡ / ਫੁੱਲ-ਸਟੈਕ ਡਿਵੈਲਪਰ ਹਾਂ। ਮੈਂ ਇਸ ਸਮੇਂ ਐਨਿਕਸ ਇਨਵੈਂਟਿਵ ਪ੍ਰਾਈਵੇਟ ਲਿਮਟਿਡ 
                  ਵਿੱਚ ਇੱਕ ਫੁੱਲ-ਸਟੈਕ ਡਿਵੈਲਪਰ ਵਜੋਂ ਕੰਮ ਕਰ ਰਿਹਾ ਹਾਂ।`
const techStack = [
  {
    name: "ਜਾਵਾਸਕ੍ਰਿਪਟ",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
    source:"https://developer.mozilla.org/en-US/docs/Web/JavaScript",
  },
  
  {
    name: "ਟਾਈਪਸਕ੍ਰਿਪਟ",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
    source:"https://www.typescriptlang.org/docs/",
  },
  {
    name: "ਪ੍ਰਤੀਕਿਰਿਆ ਜੇ.ਐਸ.",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg",
    source:"https://legacy.reactjs.org/docs/getting-started.html",

  },
  {
    name: "ਐਂਗੂਲਰ ਜੇ.ਐਸ.",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/angularjs/angularjs-original.svg",
    source:"https://angular.dev/overview",

  },  
  {
    name: "ਅਗਲਾ ਜੇ.ਐਸ.",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nextjs/nextjs-original-wordmark.svg",
    source:"https://nextjs.org/docs",
  },
  {
    name: "ਜੜਤਾ ਜੇ.ਐੱਸ.",
    link: "https://avatars.githubusercontent.com/u/47703742?s=100&v=4",
    source:"https://inertiajs.com/"
  },
  {
    name: "ਰੈਡਕਸ",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg",
    source:"https://handsonreact.com/docs/redux-thunk"
  },
  {
    name: "ਬੂਟਸਟ੍ਰੈਪ",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-plain.svg",
    source:"https://getbootstrap.com/docs/4.1/getting-started/introduction/"
  },
  {
    name: "ਸੱਸ",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/sass/sass-original.svg",
    source:"https://sass-lang.com/documentation/"
  }, 
  {
    name: "ਟੇਲਵਿੰਡ CSS",
    link: "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
    source:"https://tailwindcss.com/docs/installation/framework-guides"
  },
  {
    name: "ਮਟੀਰੀਅਲ Ui",
    link: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS5nXwOB0nj3JI6mxepmQT1QC7hucMd9Fx1ig&s",
    source:"https://mui.com/material-ui/"
  },
  {
    name: "ਨੋਡਜੇਐਸ",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg",
    source:"https://www.w3schools.com/nodejs/default.asp"
  },
  {
    name: "ਐਕਸਪ੍ਰੈਸ ਜੇ.ਐੱਸ.",
    link: "https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original-wordmark.svg",
    source:"https://devdocs.io/express/"
  },
  {
    name: "ਨੇਸਟਜੇਐਸ",
    link: "https://docs.nestjs.com/assets/logo-small-gradient.svg",
    source: "https://docs.nestjs.com/"
  },
  {
    name: "ਮੋਂਗੋ ਡੀ.ਬੀ.",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-plain.svg",
    source:"https://www.mongodb.com/docs/atlas/getting-started/"
  },
  {
    name: "ਮਾਈਐਸਕਿਊਐਲ",
    link: "https://w7.pngwing.com/pngs/962/92/png-transparent-database-mysql-backup-linux-command-line-interface-database-symbol-blue-commandline-interface-electric-blue-thumbnail.png",
    source:"https://dev.mysql.com/doc/"
  },
  {
    name: "ਡਾਕੀਆ",
    link: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
    source:"https://learning.postman.com/docs/introduction/overview/"
  },
  {
    name: "ਡਾਰਟ",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dart/dart-original.svg",
    source:"https://dart.dev/language"
  },
  {
    name: "ਹਿੱਲਣਾ",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-plain.svg",
    source:"https://docs.flutter.dev/get-started/learn-flutter"
  },
  {
    name: "ਪ੍ਰਤੀਕਿਰਿਆ ਮੂਲ",
    link: "https://pagepro.co/blog/wp-content/uploads/2020/03/react-native-logo-884x1024.png",
    source:"https://reactnative.dev/docs/getting-started"
  },
  {
    name: "HTML",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
    source:"https://developer.mozilla.org/en-US/docs/Web/HTML"
  },
  {
    name: "CSS",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-plain.svg",
    source:"https://developer.mozilla.org/en-US/docs/Web/CSS"
  },
  {
    name: "ਹੀਰੋਕੂ",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/heroku/heroku-plain.svg",
    source:"https://devcenter.heroku.com/articles/getting-started-with-nodejs"
  },
  {
    name: "ਗਿੱਟ",
    link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain.svg",
    source:"https://git-scm.com/docs"
  },
  // {
  //   name: "C Language",
  //   link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-plain.svg",
  // },
  {
    name: "ਸੀ++",
    link: "https://w7.pngwing.com/pngs/579/803/png-transparent-the-c-programming-language-programmer-computer-programming-programming-blue-logo-computer-program-thumbnail.png",
    source:"https://www.w3schools.com/cpp/"
  },
  // { name: "Azure", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-plain.svg" },
  // { name: "Docker", link: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-plain.svg" },
  {
    name: "ਫਾਇਰਬੇਸ",
    link: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
    source:"https://firebase.google.com/docs"
  },
];

const contactLinks = [
  {
    name: "LinkedIn",
    url: "https://img.icons8.com/doodle/40/000000/linkedin--v2.png",
    link: "https://www.linkedin.com/in/29159rajusingh/",
  },
  {
    name: "Github",
    url: "https://img.icons8.com/doodle/40/000000/github--v1.png",
    link: "https://github.com/rajusingh99",
  },
  {
    name: "Leetcode",
    url: "https://img.icons8.com/external-tal-revivo-color-tal-revivo/24/external-level-up-your-coding-skills-and-quickly-land-a-job-logo-color-tal-revivo.png",
    link: "https://leetcode.com/u/RajusinghofficialIND/",
  },
  {
    name: "Stack Overflow",
    url: "https://img.icons8.com/external-tal-revivo-color-tal-revivo/40/000000/external-stack-overflow-is-a-question-and-answer-site-for-professional-logo-color-tal-revivo.png",
    link: "https://stackoverflow.com/users/19923888/raju-kumar",
  },
  {
    name: "Instagram",
    url: "https://img.icons8.com/doodle/40/000000/instagram-new--v2.png",
    link: "https://www.instagram.com/mr_singh_raju_/",
  },
  {
    name: "Youtube",
    url: "https://img.icons8.com/?size=50&id=85162&format=png&color=000000",
    link: "",
    // link: "https://www.youtube.com/@Coverage_Blogs",
  },
  {
    name: "X",
    url: "https://img.icons8.com/?size=50&id=13963&format=png&color=000000",
    link: "https://x.com/RajuSingh_159",
  },
];

 const serviceData = [
  {
    name: "Front-End Development",
    desc: `ਵੈੱਬ ਡਿਜ਼ਾਈਨ ਵਿੱਚ ਵੈੱਬਸਾਈਟਾਂ ਦੇ ਉਤਪਾਦਨ ਅਤੇ ਰੱਖ-ਰਖਾਅ ਵਿੱਚ ਬਹੁਤ ਸਾਰੇ ਵੱਖ-ਵੱਖ ਹੁਨਰ
     ਅਤੇ ਵਿਸ਼ਿਆਂ ਸ਼ਾਮਲ ਹਨ। ਮੈਂ ਵੈੱਬ ਡਿਜ਼ਾਈਨ, ਯੂਜ਼ਰ ਇੰਟਰਫੇਸ ਡਿਜ਼ਾਈਨ, ਰਿਸਪਾਂਸਿਵ ਡਿਵੈਲਪਮੈਂਟ, 
     ਸਟੈਂਡਰਡ-ਕੰਪਲੈਂਟ ਕੋਡ, ਯੂਜ਼ਰ ਐਕਸਪੀਰੀਅੰਸ (UX) ਡਿਜ਼ਾਈਨ, ਅਤੇ SEO-ਅਨੁਕੂਲ ਵਿਕਾਸ 'ਤੇ 
     ਧਿਆਨ ਕੇਂਦਰਿਤ ਕੀਤਾ। ਇਹ ਪਹੁੰਚ ਇੱਕ ਸਹਿਜ ਅਤੇ ਦਿਲਚਸਪ ਯੂਜ਼ਰ ਅਨੁਭਵ ਪ੍ਰਦਾਨ ਕਰਕੇ ਤੁਹਾਡੇ 
     ਬ੍ਰਾਂਡ ਨੂੰ ਵਧਾਉਂਦੀ ਹੈ।`,
    img: "https://img.icons8.com/external-kiranshastry-lineal-color-kiranshastry/64/000000/external-web-development-coding-kiranshastry-lineal-color-kiranshastry.png",
  },
  {
    name: "Back End Development",
    desc: `ਬੈਕਐਂਡ ਡਿਵੈਲਪਮੈਂਟ ਕਿਸੇ ਵੀ ਮਜ਼ਬੂਤ ​​ਅਤੇ ਸਕੇਲੇਬਲ ਵੈੱਬ ਐਪਲੀਕੇਸ਼ਨ ਦੀ ਰੀੜ੍ਹ ਦੀ ਹੱਡੀ ਹੈ।
     ਮੇਰੀ ਮੁਹਾਰਤ ਸਰਵਰ-ਸਾਈਡ ਲਾਜਿਕ, ਡੇਟਾਬੇਸ ਪ੍ਰਬੰਧਨ, ਅਤੇ API ਏਕੀਕਰਣਾਂ ਨੂੰ ਬਣਾਉਣ ਅਤੇ ਬਣਾਈ 
     ਰੱਖਣ ਵਿੱਚ ਹੈ ਜੋ ਗਤੀਸ਼ੀਲ ਅਤੇ ਉੱਚ-ਪ੍ਰਦਰਸ਼ਨ ਵਾਲੀਆਂ ਵੈੱਬਸਾਈਟਾਂ ਨੂੰ ਸ਼ਕਤੀ ਪ੍ਰਦਾਨ ਕਰਦੇ ਹਨ। 
     ਮੈਂ ਸਰਵਰ-ਸਾਈਡ ਡਿਵੈਲਪਮੈਂਟ, ਡੇਟਾਬੇਸ ਪ੍ਰਬੰਧਨ, API ਵਿਕਾਸ ਅਤੇ ਏਕੀਕਰਣ ਸੁਰੱਖਿਆ ਅਤੇ 
     ਪ੍ਰਮਾਣਿਕਤਾ, ਸਕੇਲੇਬਿਲਟੀ ਅਤੇ ਪ੍ਰਦਰਸ਼ਨ ਅਨੁਕੂਲਨ, ਰੱਖ-ਰਖਾਅ ਅਤੇ ਸਹਾਇਤਾ 'ਤੇ ਧਿਆਨ 
     ਕੇਂਦਰਿਤ ਕਰਦਾ ਹਾਂ।`,
    img: "https://img.icons8.com/external-flaticons-flat-flat-icons/64/000000/external-backend-no-code-flaticons-flat-flat-icons.png",
  },
  {
    name: "Mobile Application Development",
    desc: `ਅਸੀਂ ਆਧੁਨਿਕ ਅਤੇ ਇੰਟਰਐਕਟਿਵ ਅਨੁਭਵ ਪ੍ਰਦਾਨ ਕਰਨ ਲਈ ਐਂਡਰਾਇਡ ਪਲੇਟਫਾਰਮਾਂ 
    'ਤੇ ਕਸਟਮ ਮੋਬਾਈਲ ਵਿਕਾਸ, ਕਰਾਸ-ਪਲੇਟਫਾਰਮ ਐਪਸ ਬਣਾਉਣਾ, ਉਪਭੋਗਤਾ ਅਨੁਭਵ ਡਿਜ਼ਾਈਨ
     ਕਰਨਾ ਅਤੇ ਚੈਟਬੋਟਸ ਅਤੇ ਵੌਇਸ-ਨਿਯੰਤਰਿਤ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ ਵਰਗੇ ਨਵੀਨਤਾਕਾਰੀ ਮੋਬਾਈਲ ਇੰਟਰਫੇਸਾਂ 
     ਨੂੰ ਏਕੀਕ੍ਰਿਤ ਕਰਨ ਸਮੇਤ ਕਈ ਤਰ੍ਹਾਂ ਦੀਆਂ ਮੋਬਾਈਲ ਐਪਲੀਕੇਸ਼ਨ ਵਿਕਾਸ ਸੇਵਾਵਾਂ ਪ੍ਰਦਾਨ ਕਰਦੇ ਹਾਂ।
    ਬਹੁਪੱਖੀ ਐਪਸ ਬਣਾਉਣਾ ਜੋ ਐਂਡਰਾਇਡ ਅਤੇ iOS ਦੋਵਾਂ ਪਲੇਟਫਾਰਮਾਂ 'ਤੇ ਸਹਿਜਤਾ ਨਾਲ ਪ੍ਰਦਰਸ਼ਨ
    ਕਰਦੇ ਹਨ, ਤੁਹਾਡੇ ਦਰਸ਼ਕਾਂ ਲਈ ਇੱਕ ਵਿਆਪਕ ਪਹੁੰਚ ਨੂੰ ਯਕੀਨੀ ਬਣਾਉਂਦੇ ਹਨ।`,
    img: "https://img.icons8.com/external-justicon-lineal-color-justicon/64/000000/external-app-development-responsive-web-design-justicon-lineal-color-justicon.png",
  },

];

const about = (
        <>
          ਮੈਂ ਇੱਕ ਸਾਫਟਵੇਅਰ ਡਿਵੈਲਪਰ ਹਾਂ ਜਿਸਦਾ {<b>{calculateAgeInYears(dob)} ਸਾਲਾਂ</b>} ਦਾ ਤਜਰਬਾ ਹੈ ਅਤੇ ਪ੍ਰੋਜੈਕਟਾਂ ਨੂੰ ਸੰਕਲਪ 
          ਤੋਂ ਸੰਪੂਰਨਤਾ ਤੱਕ ਲਿਜਾਣ ਦਾ ਇੱਕ ਮਜ਼ਬੂਤ ​​ਟਰੈਕ ਰਿਕਾਰਡ ਹੈ। ਮੈਂ ਵਾਇਰਫ੍ਰੇਮ ਅਤੇ ਡਿਜ਼ਾਈਨ
         ਸੰਕਲਪਾਂ ਨੂੰ ਉੱਚ-ਪ੍ਰਦਰਸ਼ਨ ਵਾਲੇ ਸਾਫਟਵੇਅਰ ਐਪਲੀਕੇਸ਼ਨਾਂ ਵਿੱਚ ਬਦਲਣ ਵਿੱਚ ਉੱਤਮ ਹਾਂ, ਸਾਫ਼,
          ਮੁੜ ਵਰਤੋਂ ਯੋਗ ਅਤੇ ਕੁਸ਼ਲ ਕੋਡ ਦੁਆਰਾ ਇੱਕ ਸਹਿਜ ਉਪਭੋਗਤਾ ਅਨੁਭਵ ਨੂੰ ਯਕੀਨੀ ਬਣਾਉਂਦਾ ਹਾਂ। 
          ਮੇਰਾ ਜਨੂੰਨ ਡਿਜ਼ਾਈਨ, ਤਕਨਾਲੋਜੀ ਅਤੇ ਨਵੀਨਤਾ ਨੂੰ ਮਿਲਾਉਣ ਵਿੱਚ ਹੈ, ਹਰੇਕ ਪ੍ਰੋਜੈਕਟ ਨੂੰ ਸ਼ੁਰੂਆਤੀ 
          ਵਿਚਾਰ ਤੋਂ ਅੰਤਿਮ ਰਿਲੀਜ਼ ਤੱਕ ਮਾਰਗਦਰਸ਼ਨ ਕਰਦਾ ਹੈ। ਮੈਨੂੰ ਫਰੰਟਐਂਡ ਅਤੇ ਬੈਕਐਂਡ ਦੋਵਾਂ ਦਾ 
          ਮਜ਼ਬੂਤ ​​ਗਿਆਨ ਹੈ। ਵਰਤਮਾਨ ਵਿੱਚ, ਮੈਂ ਬੈਕਐਂਡ ਵਿਕਾਸ 'ਤੇ ਕੇਂਦ੍ਰਿਤ ਹਾਂ, ਮੇਰੇ ਕੰਮ ਦੀ ਤਕਨੀਕੀ 
          ਨੀਂਹ ਨੂੰ ਚਲਾਉਂਦਾ ਹਾਂ।
        </>
        )
const detailAbout = (
  <>
    ਮੈਂ <strong>ਟੰਡਸਪੁਰ, ਸੀਤਾਮੜੀ, ਬਿਹਾਰ</strong> ਦਾ ਰਹਿਣ ਵਾਲਾ ਹਾਂ। 
    ਮੈਂ ਇੱਕ <strong>ਜੋਸ਼ੀਲਾ ਸਾਫਟਵੇਅਰ ਇੰਜੀਨੀਅਰ</strong> ਹਾਂ ਜਿਸਦਾ 
    <strong> ਚੰਡੀਗੜ੍ਹ</strong> ਅਤੇ <strong>ਮੋਹਾਲੀ</strong> ਵਿੱਚ ਤਜਰਬਾ ਹੈ।{" "}
    <span>
      ਬਹੁਤ ਸਾਰੇ ਲੋਕ ਮੈਨੂੰ <strong>ਰਾਜੂ ਸਿੰਘ ਬਿਹਾਰ</strong> ਜਾਂ{" "}
      <strong>ਭਾਰਤੀ ਸਾਫਟਵੇਅਰ ਇੰਜੀਨੀਅਰ</strong> ਵਜੋਂ ਜਾਣਦੇ ਹਨ। 
      ਮੈਂ <strong>ਮਲਟੀਪਲ ਤਕਨਾਲੋਜੀਆਂ</strong> ਦੀ ਵਰਤੋਂ ਕਰਕੇ 
      ਸਕੇਲੇਬਲ <strong>ਫੁੱਲ ਸਟੈਕ ਐਪਸ</strong> ਅਤੇ <strong>ਵੈੱਬਸਾਈਟਾਂ</strong> ਬਣਾਉਂਦਾ ਹਾਂ।
    </span>
  </>
);
        

const technologies_tools = `ਅਤਿ-ਆਧੁਨਿਕ ਤਕਨਾਲੋਜੀਆਂ ਅਤੇ ਭਰੋਸੇਮੰਦ ਓਪਨ-ਸੋਰਸ ਸੌਫਟਵੇਅਰ ਦੇ ਸੁਮੇਲ ਦੀ ਵਰਤੋਂ ਕਰਕੇ 
                        ਮੈਂ ਸਮਾਰਟਫ਼ੋਨਾਂ, ਟੈਬਲੇਟਾਂ, ਲੈਪਟਾਪਾਂ ਅਤੇ ਡੈਸਕਟਾਪਾਂ ਲਈ ਉਪਭੋਗਤਾ-ਕੇਂਦ੍ਰਿਤ, ਪ੍ਰਦਰਸ਼ਨਸ਼ੀਲ ਐਪਸ ਅਤੇ
                        ਵੈੱਬਸਾਈਟਾਂ ਬਣਾਉਂਦਾ ਹਾਂ।`;


const projects = [
  // webs
  {
    src: a1residential,
    type:"web",
    link:"https://www.a1-builders.com/",
    name:"A1ResidentialBuilders",
    figma:"https://www.figma.com/design/r5BUGIFP1Kzw2tvAEI3iv1/Untitled?node-id=0-1&p=f",
    adminFigma:"https://www.figma.com/design/g5AY22eZS5zAaIIFSFlUpG/A1---Admin?node-id=0-1&p=f",
    isSecure:false,
    description:`ਇਸ ਲਈ ਜ਼ਮੀਨੀ ਖੇਤਰ ਦੇ ਅਧਿਕਾਰਾਂ ਦਾ ਕੰਮ ਕਰਨ ਅਤੇ ਟੀਚਿਆਂ ਦੀ ਚੋਣ ਕਰਨ ਲਈ ਸਭ ਤੋਂ ਵੱਧ ਤਿਆਰ ਹਨ। 
    ਇਹ ਔਰਤ ਤੋਂ ਲੈ ਕੇ ਬਰਖਾਸਤਗੀ ਤੱਕ, ਸਫ਼ਰ ਨੂੰ ਸ਼ਾਮਲ ਕਰਦੀ ਹੈ। ਸਰਵ ਵਿਆਪਕ ਪੱਧਰ 'ਤੇ ਕੰਟਰੋਲ, ਸਥਿਤੀ ਨੂੰ ਕੰਟਰੋਲ ਕਰਨ
    ਲਈ ਕਾਰਵਾਈ ਕਰਨ ਲਈ ਇੱਕ ਸਥਿਤੀ ਨੂੰ ਬਣਾਉਣ ਦੀ ਲੋੜ ਹੈ। ਇਸ ਲਈ ਪਾਰਟੀ ਦੇ ਟੀਚਿਆਂ ਦੇ ਸੂਬੇ ਵਿੱਚ ਕੰਮ ਕਰਨ ਅਤੇ 
    ਮਾਪਣ ਦੀ ਵੀ ਲੋੜ ਹੁੰਦੀ ਹੈ। ਜਿੱਤ ਜਿੱਤ ਦੇ ਪ੍ਰਬੰਧਕਾਂ ਅਤੇ ਬਿਆਨਾਂ ਦੇ ਪ੍ਰਸਾਰਣ, ਸੰਚਾਰ ਕਰਨ ਅਤੇ ਬਣਾਉਣ ਦੀ ਯੋਗਤਾ ' 
    ਤੈਨਾਤ ਕਰਦਾ ਹੈ। ਸਭ ਤੋਂ ਵਧੀਆ ਪ੍ਰਬੰਧਕਾਂ ਨੂੰ ਕੰਮ ਕਰਨ ਲਈ ਕੋਚਿਮ, ਕਾਰਜ ਨੂੰ ਸੁਧਾਰਣ ਲਈ ਵੱਡੇ ਪੱਧਰ 'ਤੇ ਕੰਮ ਕਰਨਾ।
    ਪਛਾਣਦੇ ਹਨ। ਕਿ ਬਹੁਤ ਸਾਰੇ ਕੰਮ ਅਤੇ ਫਰਜ਼ ਕੈਫੇ ਜਾਰੀ ਹੁੰਦੇ ਹਨ, ਸਾਰੇ ਮਾਮਲੇ ਦੀਆਂ ਸ਼੍ਰੇਣੀਆਂ ਵਿੱਚ ਸ਼ਾਮਲ ਹੁੰਦੇ ਹਨ।`
  },
  {
    src: prontocasecase,
    link:"https://prontocasecash.com/",
    name:"Pronto Case Cash",
    figma:"https://www.figma.com/design/nWX94AvnPPq8B6w4Y1mQtl/Law-firm-Probationary-Period?node-id=0-1&p=f",
    isSecure:false,
    type:"web",
    description:`ਕੀ ਤੁਸੀਂ ਕਿਸੇ ਵਾਹਨ ਜਾਂ ਜਾਇਦਾਦ ਦੀ ਘਟਨਾ ਜਿਵੇਂ ਕਿ ਤਿਲਕਣ ਅਤੇ ਡਿੱਗਣ ਵਿੱਚ ਜ਼ਖਮੀ ਹੋਏ ਹੋ? ਕੀ ਤੁਹਾਡਾ 
    ਕੋਈ ਕੇਸ ਲੰਬਿਤ ਹੈ ਪਰ ਤੁਹਾਨੂੰ ਹੁਣ ਮਦਦ ਲਈ ਪੈਸੇ ਦੀ ਲੋੜ ਹੈ? ਅਸੀਂ ਹਰ ਰੋਜ਼ ਤੁਹਾਡੇ ਵਰਗੇ ਲੋਕਾਂ ਦੀ ਮਦਦ ਕਰਦੇ ਹਾਂ ਜੋ 
    ਆਪਣੇ ਮੁਕੱਦਮੇ ਦੇ ਨਿਪਟਾਰੇ ਲਈ ਇੱਕ ਹੋਰ ਸਾਲ ਇੰਤਜ਼ਾਰ ਨਹੀਂ ਕਰ ਸਕਦੇ। ਸਾਡੀ ਅਰਜ਼ੀ ਪ੍ਰਕਿਰਿਆ ਵਿੱਚ 3 ਮਿੰਟ ਤੋਂ ਵੀ ਘੱਟ 
    ਸਮਾਂ ਲੱਗਦਾ ਹੈ ਅਤੇ ਅਕਸਰ ਅਸੀਂ ਉਸੇ ਦਿਨ ਤੁਹਾਡੇ ਲਈ ਜਵਾਬ ਪ੍ਰਾਪਤ ਕਰ ਸਕਦੇ ਹਾਂ। ਜੇਕਰ ਤੁਹਾਨੂੰ ਸਾਡੀ ਮਦਦ ਦੀ ਲੋੜ ਹੈ, 
    ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ ਹੇਠਾਂ ਦਿੱਤੇ "ਆਪਣਾ ਕੇਸ ਜਮ੍ਹਾਂ ਕਰੋ" ਬਟਨ 'ਤੇ ਕਲਿੱਕ ਕਰੋ ਤਾਂ ਜੋ ਅਸੀਂ ਤੁਹਾਡੇ ਲਈ ਕੰਮ 'ਤੇ ਜਾ ਸਕੀਏ।`
  },
  {
    src: waa,
    link:"https://weareappointments.com/",
    name:"We are Appointments",
    type:"web",
    figma:null,
    isSecure:false,
    description:`ਇਸ ਲਈ ਜ਼ਮੀਨੀ ਖੇਤਰ ਦੇ ਅਧਿਕਾਰਾਂ ਦਾ ਕੰਮ ਕਰਨ ਅਤੇ ਟੀਚਿਆਂ ਦੀ ਚੋਣ ਕਰਨ ਲਈ ਸਭ ਤੋਂ ਵੱਧ ਤਿਆਰ ਹਨ। 
    ਇਹ ਔਰਤ ਤੋਂ ਲੈ ਕੇ ਬਰਖਾਸਤਗੀ ਤੱਕ, ਸਫ਼ਰ ਨੂੰ ਸ਼ਾਮਲ ਕਰਦੀ ਹੈ। ਸਰਵ ਵਿਆਪਕ ਪੱਧਰ 'ਤੇ ਕੰਟਰੋਲ, ਸਥਿਤੀ ਨੂੰ ਕੰਟਰੋਲ ਕਰਨ 
    ਲਈ ਕਾਰਵਾਈ ਕਰਨ ਲਈ ਇੱਕ ਸਥਿਤੀ ਨੂੰ ਬਣਾਉਣ ਦੀ ਲੋੜ ਹੈ। ਇਸ ਲਈ ਪਾਰਟੀ ਦੇ ਟੀਚਿਆਂ ਦੇ ਸੂਬੇ ਵਿੱਚ ਕੰਮ ਕਰਨ ਅਤੇ ਮਾਪਣ 
    ਦੀ ਵੀ ਲੋੜ ਹੁੰਦੀ ਹੈ। ਜਿੱਤ ਜਿੱਤ ਦੇ ਪ੍ਰਬੰਧਕਾਂ ਅਤੇ ਬਿਆਨਾਂ ਦੇ ਪ੍ਰਸਾਰਣ, ਸੰਚਾਰ ਕਰਨ ਅਤੇ ਬਣਾਉਣ ਦੀ ਯੋਗਤਾ ' ਤੈਨਾਤ ਕਰਦਾ ਹੈ। 
    ਸਭ ਤੋਂ ਵਧੀਆ ਪ੍ਰਬੰਧਕਾਂ ਨੂੰ ਕੰਮ ਕਰਨ ਲਈ ਕੋਚਿਮ, ਕਾਰਜ ਨੂੰ ਸੁਧਾਰਣ ਲਈ ਵੱਡੇ ਪੱਧਰ 'ਤੇ ਕੰਮ ਕਰਨਾ। ਪਛਾਣਦੇ ਹਨ। ਕਿ ਬਹੁਤ 
    ਸਾਰੇ ਕੰਮ ਅਤੇ ਫਰਜ਼ ਕੈਫੇ ਜਾਰੀ ਹੁੰਦੇ ਹਨ, ਸਾਰੇ ਮਾਮਲੇ ਦੀਆਂ ਸ਼੍ਰੇਣੀਆਂ ਵਿੱਚ ਸ਼ਾਮਲ ਹੁੰਦੇ ਹਨ।`
  },
  {
    src: crm,
    link:"https://drive.google.com/drive/folders/1sHENXJl4yReoVktjcp1u3kxXDs2VuDIs?usp=sharing",
    name:"Employee Management",
    type:"web",
    figma:null,
    isSecure:false,
    description:`ਕਰਮਚਾਰੀ ਪ੍ਰਬੰਧਨ ਕਰਮਚਾਰੀਆਂ ਨੂੰ ਸੰਗਠਨ ਦੇ ਸਮੁੱਚੇ ਮਿਸ਼ਨ ਅਤੇ ਟੀਚਿਆਂ ਨੂੰ ਪ੍ਰਾਪਤ ਕਰਨ ਲਈ ਆਪਣਾ ਸਭ ਤੋਂ 
    ਵਧੀਆ ਪ੍ਰਦਰਸ਼ਨ ਕਰਨ ਵਿੱਚ ਮਦਦ ਕਰਨ ਦਾ ਕੰਮ ਹੈ। ਇਹ ਭਰਤੀ ਤੋਂ ਲੈ ਕੇ ਬਰਖਾਸਤਗੀ ਤੱਕ, ਪੂਰੇ ਕਰਮਚਾਰੀ ਸਫ਼ਰ ਨੂੰ ਸ਼ਾਮਲ 
    ਕਰਦਾ ਹੈ। ਹਾਲਾਂਕਿ ਕੋਈ ਸਰਵ ਵਿਆਪਕ ਫਾਰਮੂਲਾ ਨਹੀਂ ਹੈ, ਪ੍ਰਭਾਵਸ਼ਾਲੀ ਕਰਮਚਾਰੀ ਪ੍ਰਬੰਧਨ ਲਈ ਕਰਮਚਾਰੀਆਂ ਨਾਲ ਉਨ੍ਹਾਂ ਦੇ 
    ਕਾਰਜਕਾਲ ਦੌਰਾਨ ਸਬੰਧ ਬਣਾਉਣ ਦੀ ਲੋੜ ਹੁੰਦੀ ਹੈ। ਇਸ ਲਈ ਉਨ੍ਹਾਂ ਦੇ ਪੇਸ਼ੇਵਰ ਟੀਚਿਆਂ ਦੇ ਸਬੰਧ ਵਿੱਚ ਉਨ੍ਹਾਂ ਦੇ ਕੰਮ ਦੀ 
    ਨਿਗਰਾਨੀ ਅਤੇ ਮਾਪਣ ਦੀ ਵੀ ਲੋੜ ਹੁੰਦੀ ਹੈ। ਪ੍ਰਭਾਵਸ਼ਾਲੀ ਕਰਮਚਾਰੀ ਪ੍ਰਬੰਧਨ ਅਕਸਰ ਵਿਅਕਤੀਗਤ ਪ੍ਰਬੰਧਕਾਂ ਅਤੇ ਉਨ੍ਹਾਂ ਦੀਆਂ 
    ਰਿਪੋਰਟਾਂ ਨਾਲ ਪ੍ਰੇਰਿਤ ਕਰਨ, ਸੰਚਾਰ ਕਰਨ ਅਤੇ ਵਿਸ਼ਵਾਸ ਬਣਾਉਣ ਦੀ ਉਨ੍ਹਾਂ ਦੀ ਯੋਗਤਾ 'ਤੇ ਨਿਰਭਰ ਕਰਦਾ ਹੈ। ਸਭ ਤੋਂ 
    ਵਧੀਆ ਪ੍ਰਬੰਧਕ ਆਪਣੇ ਕਰਮਚਾਰੀਆਂ ਲਈ ਕੋਚ ਵਜੋਂ ਕੰਮ ਕਰਦੇ ਹਨ, ਉਨ੍ਹਾਂ ਨੂੰ ਸੁਧਾਰ ਕਰਨ ਲਈ ਚੁਣੌਤੀ ਦਿੰਦੇ ਹੋਏ ਉਨ੍ਹਾਂ 
    ਦੁਆਰਾ ਕੀਤੇ ਜਾ ਰਹੇ ਮਹਾਨ ਕੰਮ ਨੂੰ ਪਛਾਣਦੇ ਹਨ। ਜਦੋਂ ਕਿ ਬਹੁਤ ਸਾਰੇ ਕੰਮ ਅਤੇ ਫਰਜ਼ ਹਨ ਜੋ ਕਰਮਚਾਰੀ ਪ੍ਰਬੰਧਨ ਦੇ 
    ਅਧੀਨ ਆਉਂਦੇ ਹਨ, ਲਗਭਗ ਸਾਰੇ ਪੰਜ ਸ਼੍ਰੇਣੀਆਂ ਵਿੱਚੋਂ ਇੱਕ ਵਿੱਚ ਫਿੱਟ ਹੋ ਸਕਦੇ ਹਨ।`
  },
  {
    src: TrendingNow,
    link:"",
    name:"Trend now",
    type:"web",
    figma:"https://www.figma.com/design/shmxWL5FKRO5GNOPPopBg6/PLAY",
    isSecure:false,
    description:`ਸ਼ਾਨਦਾਰ ਗੇਮਿੰਗ ਅਨੁਭਵ ਲਈ ਤਿਆਰ ਹੋ ਜਾਓ, ਜਿੱਥੇ ਐਕਸ਼ਨ, ਐਡਵੈਂਚਰ ਅਤੇ ਮਨੋਰੰਜਨ ਆਪਸ ਵਿੱਚ ਟਕਰਾਉਂਦੇ ਹਨ! 
    ਭਾਵੇਂ ਤੁਸੀਂ ਇੱਕ ਆਮ ਖਿਡਾਰੀ ਹੋ ਜਾਂ ਇੱਕ ਹਾਰਡਕੋਰ ਈ-ਸਪੋਰਟਸ ਪ੍ਰਸ਼ੰਸਕ, ਅਸੀਂ ਤੁਹਾਨੂੰ ਮਹਾਂਕਾਵਿ ਗੇਮਪਲੇ, ਪੇਸ਼ੇਵਰ ਸੁਝਾਅ, ਨਵੀਨਤਮ 
    ਗੇਮਿੰਗ ਖ਼ਬਰਾਂ, ਅਤੇ ਤੀਬਰ ਮਲਟੀਪਲੇਅਰ ਲੜਾਈਆਂ ਨਾਲ ਕਵਰ ਕੀਤਾ ਹੈ। ਸਾਡੇ ਭਾਈਚਾਰੇ ਵਿੱਚ ਸ਼ਾਮਲ ਹੋਵੋ, ਆਪਣੇ ਹੁਨਰਾਂ ਦਾ ਪੱਧਰ 
    ਵਧਾਓ, ਅਤੇ ਗੇਮਿੰਗ ਦੀ ਦੁਨੀਆ ਵਿੱਚ ਅੱਗੇ ਰਹੋ!... ਨਾਨ-ਸਟਾਪ ਗੇਮਿੰਗ ਸਮੱਗਰੀ ਲਈ LIKE, SHARE ਅਤੇ SUBSCRIBE ਦਬਾਓ! 
    🔔 ਅੱਪਡੇਟ ਲਈ ਜੁੜੇ ਰਹੋ! 🚀 #PLAY #GamingCommunity #GameOn #LevelUp`
  },
  {
    src: PathFinder,
    link:"https://path-finder-google-maps.netlify.app/",
    name:"Path Finder by Google maps",
    type:"web",
    figma:null,
    isSecure:false,
    description:`ਇਹ ਤੁਹਾਡੇ ਸਥਾਨ ਤੋਂ ਮੰਜ਼ਿਲ ਤੱਕ ਦਾ ਰਸਤਾ ਲੱਭਣ ਦੇ ਯੋਗ ਹੈ।`
  },
  {
    src: relaxNow,
    link:"https://nwnt.ai/",
    name:"NWNT",
    type:"web",
    figma:null,
    isSecure:false,
    description:`NWNT ਤਣਾਅ ਅਤੇ/ਜਾਂ ਜੀਵਨ ਸ਼ੈਲੀ ਦੇ ਮੁੱਦਿਆਂ ਤੋਂ ਪੈਦਾ ਹੋਣ ਵਾਲੀਆਂ ਮਾਨਸਿਕ, ਭਾਵਨਾਤਮਕ ਅਤੇ ਵਿਵਹਾਰ ਸੰਬੰਧੀ 
    ਸਿਹਤ ਸਮੱਸਿਆਵਾਂ ਲਈ ਇੱਕ-ਸਟਾਪ ਹੱਲ ਹੈ।`
  },
  {
    src: iKidz,
    link:"https://ikidzschools.com/",
    name:"India's First Tech-Enabled Preschool",
    type:"web",
    figma:null,
    isSecure:false,
    description:`ਭਾਰਤ ਦਾ ਪਹਿਲਾ ਅਤੇ ਇਕਲੌਤਾ ਪ੍ਰੀਸਕੂਲ ਜਿਸਨੇ ਸਾਡੇ ਆਪਣੇ ਘਰ ਵਿੱਚ ਵਿਕਸਤ ਐਪ, IKidz ਨਾਲ ਪ੍ਰੀਸਕੂਲ ਵਿੱਚ 
    ਔਗਮੈਂਟੇਡ ਰਿਐਲਿਟੀ ਨੂੰ ਸ਼ਾਮਲ ਕੀਤਾ ਹੈ, ਸਿੱਖਣ ਨੂੰ ਇੱਕ ਨਵਾਂ ਅਰਥ ਦਿੰਦਾ ਹੈ। ਇਸ ਵਿੱਚ ਮਜ਼ੇਦਾਰ ਸਿੱਖਣ ਦੇ ਮਾਡਿਊਲ ਸ਼ਾਮਲ ਹਨ ਜੋ
    ਬੱਚਿਆਂ ਨੂੰ ਅੱਖਰ, ਨੰਬਰ, ਆਕਾਰ, ਰੁੱਤਾਂ ਦੀ ਗਿਣਤੀ ਅਤੇ ਹੋਰ ਬਹੁਤ ਕੁਝ ਸਿੱਖਣ ਵਿੱਚ ਮਦਦ ਕਰਦੇ ਹਨ। ਇਹ ਸਭ ਇੱਕ ਨਵੇਂ ਤਰੀਕੇ 
    ਨਾਲ ਜੋ ਭਾਰਤ ਵਿੱਚ ਕੋਈ ਹੋਰ ਪਲੇਸਕੂਲ ਨਹੀਂ ਕਰ ਸਕਦਾ। ਸਾਰੇ IKidz ਸਕੂਲ ਔਗਮੈਂਟੇਡ ਰਿਐਲਿਟੀ ਸਮਰੱਥ ਫਲੈਸ਼ ਕਾਰਡਾਂ ਅਤੇ 
    ਟੈਬਲੇਟਾਂ ਨਾਲ ਲੈਸ ਹਨ।`
  },
  {
    src: pisteyo,
    link:"https://teams.microsoft.com/v2/",
    name:"MicroSoft Pisteyo App",
    type:"web",
    figma:null,
    isSecure:false,
    description:`ਪਿਸਟੀਓ ਇੱਕ ਏਆਈ ਸਲਾਹਕਾਰ ਫਰਮ ਹੈ ਜੋ ਮਾਈਕ੍ਰੋਸਾਫਟ ਕੋਪਾਇਲਟ ਅਪਣਾਉਣ ਵਿੱਚ ਮਾਹਰ ਹੈ, ਜੋ ਅਨੁਕੂਲਿਤ 
    ਸਿਖਲਾਈ, ਵਰਕਫਲੋ ਆਟੋਮੇਸ਼ਨ, ਅਤੇ ਕਸਟਮ ਜੀਪੀਟੀ ਚੈਟਬੋਟਸ ਦੀ ਪੇਸ਼ਕਸ਼ ਕਰਦੀ ਹੈ। ਉਨ੍ਹਾਂ ਦੀ ਮਾਈਕ੍ਰੋਸਾਫਟ ਟੀਮਜ਼ ਐਪ 
    (ਬੀਟਾ ਵਿੱਚ) ਕੋਪਾਇਲਟ ਵਰਤੋਂ ਲਈ ਸਕਾਰਾਤਮਕ ਆਦਤਾਂ ਅਤੇ ਸਭ ਤੋਂ ਵਧੀਆ ਅਭਿਆਸਾਂ ਨੂੰ ਉਤਸ਼ਾਹਿਤ ਕਰਦੀ ਹੈ, ਉਤਪਾਦਕਤਾ 
    ਵਧਾਉਂਦੀ ਹੈ ਅਤੇ ਵਰਕਫਲੋ ਨੂੰ ਸੁਚਾਰੂ ਬਣਾਉਂਦੀ ਹੈ।`
  },
  {
    src: monday,
    link:"https://terdia.monday.com/boards",
    name:"Monday.com Install App feature",
    type:"web",
    figma:null,
    isSecure:false,
    description:`ਪ੍ਰੋਜੈਕਟ ਦੀ ਪ੍ਰਗਤੀ ਨੂੰ ਸੰਗਠਿਤ ਅਤੇ ਟਰੈਕ ਕਰਨ ਲਈ Monday.com ਦੀ ਬੋਰਡ ਵਿਸ਼ੇਸ਼ਤਾ ਦਾ ਲਾਭ ਉਠਾਇਆ ਗਿਆ, 
    ਜਿਸ ਨਾਲ ਸਹਿਜ ਸੰਚਾਰ ਅਤੇ ਕਾਰਜ ਪ੍ਰਬੰਧਨ ਦੀ ਸਹੂਲਤ ਮਿਲਦੀ ਹੈ, ਜਿਸਦੇ ਨਤੀਜੇ ਵਜੋਂ ਟੀਮ ਸਹਿਯੋਗ ਅਤੇ ਪ੍ਰੋਜੈਕਟ ਕੁਸ਼ਲਤਾ ਵਿੱਚ ਸੁਧਾਰ 
    ਹੁੰਦਾ ਹੈ।`
  },
  {
    src: talktoenergy,
    link:"https://demo.talktomyenergy.ai",
    name:"Talk to Energy",
    type:"web",
    figma:"https://www.figma.com/design/CB5fTEjZvptQ81oe2GiCfh/Mohit_works_21-Apr?node-id=48-2&p=f",
    isSecure:false,
    description:`ਟਾਕ ਟੂ ਮਾਈ ਐਨਰਜੀ - ਸਮਾਰਟ ਐਨਰਜੀ ਇਨਸਾਈਟਸ ਅਤੇ ਏਆਈ ਚੈਟਬੋਟ ਟਾਕ ਟੂ ਮਾਈ ਐਨਰਜੀ ਇੱਕ ਉੱਨਤ 
    ਪਲੇਟਫਾਰਮ ਹੈ ਜੋ ਇੱਕ ਇੰਟਰਐਕਟਿਵ ਚੈਟਬੋਟ ਰਾਹੀਂ ਏਆਈ-ਸੰਚਾਲਿਤ ਊਰਜਾ ਇਨਸਾਈਟਸ ਪ੍ਰਦਾਨ ਕਰਦਾ ਹੈ। ਇਹ ਉਪਭੋਗਤਾਵਾਂ ਨੂੰ 
    ਮਾਸਿਕ ਗ੍ਰਾਫਾਂ ਅਤੇ ਰਿਪੋਰਟਾਂ ਨਾਲ ਉਨ੍ਹਾਂ ਦੀ ਊਰਜਾ ਖਪਤ ਦੀ ਨਿਗਰਾਨੀ ਅਤੇ ਵਿਸ਼ਲੇਸ਼ਣ ਕਰਨ ਵਿੱਚ ਮਦਦ ਕਰਦਾ ਹੈ, ਜਿਸ ਨਾਲ 
    ਊਰਜਾ ਪ੍ਰਬੰਧਨ ਸਰਲ ਅਤੇ ਕੁਸ਼ਲ ਹੁੰਦਾ ਹੈ। ਚੈਟਬੋਟ ਸਵਾਲਾਂ ਦੇ ਜਵਾਬ ਦਿੰਦਾ ਹੈ, ਰੀਅਲ-ਟਾਈਮ ਡੇਟਾ ਪ੍ਰਦਾਨ ਕਰਦਾ ਹੈ, ਅਤੇ 
    ਊਰਜਾ ਵਰਤੋਂ ਨੂੰ ਅਨੁਕੂਲ ਬਣਾਉਣ ਲਈ ਕਾਰਵਾਈਯੋਗ ਇਨਸਾਈਟਸ ਪ੍ਰਦਾਨ ਕਰਦਾ ਹੈ।`
  },
  {
    src: highcourt,
    link:"https://punjabharyanahighcourtbar.in",
    name:"Punjab & Haryana Hight Court Bar Association",
    type:"web",
    isSecure:false,
    figma:null,
    description:`ਪੰਜਾਬ ਅਤੇ ਹਰਿਆਣਾ ਹਾਈ ਕੋਰਟ ਬਾਰ ਐਸੋਸੀਏਸ਼ਨ ਇੱਕ ਵੱਕਾਰੀ ਕਾਨੂੰਨੀ ਸੰਸਥਾ ਹੈ ਜੋ ਪੰਜਾਬ ਅਤੇ ਹਰਿਆਣਾ 
    ਹਾਈ ਕੋਰਟ ਵਿੱਚ ਪ੍ਰੈਕਟਿਸ ਕਰਨ ਵਾਲੇ ਵਕੀਲਾਂ ਦੀ ਨੁਮਾਇੰਦਗੀ ਕਰਦੀ ਹੈ। ਨਿਆਂ, ਕਾਨੂੰਨੀ ਨੈਤਿਕਤਾ ਅਤੇ ਪੇਸ਼ੇਵਰ ਉੱਤਮਤਾ ਨੂੰ 
    ਬਰਕਰਾਰ ਰੱਖਣ ਲਈ ਵਚਨਬੱਧ, ਇਹ ਐਸੋਸੀਏਸ਼ਨ ਨਿਆਂਪਾਲਿਕਾ ਅਤੇ ਕਾਨੂੰਨੀ ਪੇਸ਼ੇਵਰਾਂ ਵਿਚਕਾਰ ਇੱਕ ਮਹੱਤਵਪੂਰਨ ਕੜੀ ਵਜੋਂ 
    ਕੰਮ ਕਰਦੀ ਹੈ। ਕਾਨੂੰਨੀ ਉੱਤਮਤਾ ਦੀ ਇੱਕ ਅਮੀਰ ਵਿਰਾਸਤ ਦੇ ਨਾਲ, ਐਸੋਸੀਏਸ਼ਨ ਕਾਨੂੰਨੀ ਜਾਗਰੂਕਤਾ ਅਤੇ ਪੇਸ਼ੇਵਰ ਵਿਕਾਸ ਨੂੰ 
    ਉਤਸ਼ਾਹਿਤ ਕਰਨ ਲਈ ਸੈਮੀਨਾਰ, ਵਰਕਸ਼ਾਪਾਂ ਅਤੇ ਸਮਾਗਮਾਂ ਦਾ ਆਯੋਜਨ ਕਰਦੀ ਹੈ। ਇੱਕ ਮਜ਼ਬੂਤ ​​ਕਾਨੂੰਨੀ ਭਾਈਚਾਰੇ ਨੂੰ 
    ਉਤਸ਼ਾਹਿਤ ਕਰਨ ਲਈ ਸਮਰਪਿਤ, ਇਹ ਖੇਤਰ ਵਿੱਚ ਨਿਆਂ ਦੇ ਸੁਚਾਰੂ ਪ੍ਰਸ਼ਾਸਨ ਨੂੰ ਯਕੀਨੀ ਬਣਾਉਣ ਵਿੱਚ ਇੱਕ ਮਹੱਤਵਪੂਰਨ 
    ਭੂਮਿਕਾ ਨਿਭਾਉਂਦਾ ਹੈ।`
  },
  {
    src: hcba,
    link:"https://hcba.anixinventive.com/",
    name:"Hight Court Bar Association",
    type:"web",
    figma:null,
    isSecure:true,
    description:`ਪੰਜਾਬ ਅਤੇ ਹਰਿਆਣਾ ਹਾਈ ਕੋਰਟ ਬਾਰ ਐਸੋਸੀਏਸ਼ਨ ਇੱਕ ਵੱਕਾਰੀ ਕਾਨੂੰਨੀ ਸੰਸਥਾ ਹੈ ਜੋ ਪੰਜਾਬ ਅਤੇ ਹਰਿਆਣਾ ਹਾਈ ਕੋਰਟ 
    ਵਿੱਚ ਪ੍ਰੈਕਟਿਸ ਕਰਨ ਵਾਲੇ ਵਕੀਲਾਂ ਦੀ ਨੁਮਾਇੰਦਗੀ ਕਰਦੀ ਹੈ। ਨਿਆਂ, ਕਾਨੂੰਨੀ ਨੈਤਿਕਤਾ ਅਤੇ ਪੇਸ਼ੇਵਰ ਉੱਤਮਤਾ ਨੂੰ ਬਰਕਰਾਰ ਰੱਖਣ ਲਈ 
    ਵਚਨਬੱਧ, ਇਹ ਐਸੋਸੀਏਸ਼ਨ ਨਿਆਂਪਾਲਿਕਾ ਅਤੇ ਕਾਨੂੰਨੀ ਪੇਸ਼ੇਵਰਾਂ ਵਿਚਕਾਰ ਇੱਕ ਮਹੱਤਵਪੂਰਨ ਕੜੀ ਵਜੋਂ ਕੰਮ ਕਰਦੀ ਹੈ। ਕਾਨੂੰਨੀ ਉੱਤਮਤਾ 
    ਦੀ ਇੱਕ ਅਮੀਰ ਵਿਰਾਸਤ ਦੇ ਨਾਲ, ਐਸੋਸੀਏਸ਼ਨ ਕਾਨੂੰਨੀ ਜਾਗਰੂਕਤਾ ਅਤੇ ਪੇਸ਼ੇਵਰ ਵਿਕਾਸ ਨੂੰ ਉਤਸ਼ਾਹਿਤ ਕਰਨ ਲਈ ਸੈਮੀਨਾਰ, ਵਰਕਸ਼ਾਪਾਂ 
    ਅਤੇ ਸਮਾਗਮਾਂ ਦਾ ਆਯੋਜਨ ਕਰਦੀ ਹੈ। ਇੱਕ ਮਜ਼ਬੂਤ ​​ਕਾਨੂੰਨੀ ਭਾਈਚਾਰੇ ਨੂੰ ਉਤਸ਼ਾਹਿਤ ਕਰਨ ਲਈ ਸਮਰਪਿਤ, ਇਹ ਖੇਤਰ ਵਿੱਚ ਨਿਆਂ ਦੇ 
    ਸੁਚਾਰੂ ਪ੍ਰਸ਼ਾਸਨ ਨੂੰ ਯਕੀਨੀ ਬਣਾਉਣ ਵਿੱਚ ਇੱਕ ਮਹੱਤਵਪੂਰਨ ਭੂਮਿਕਾ ਨਿਭਾਉਂਦਾ ਹੈ।`
  },
  {
    src: swing,
    link:"https://opaqueswingers.com/index",
    name:"The Ultimate Swinger Dating App",
    type:"web",
    figma:"https://drive.google.com/file/d/1XMdd30aiIAd4TT8xq0KK97TkvkQ0NKpc/view?usp=sharing",
    isSecure:true,
    description:`ਸਾਹਸੀ ਜੋੜਿਆਂ ਅਤੇ ਸਿੰਗਲਜ਼ ਲਈ ਤਿਆਰ ਕੀਤੀ ਗਈ ਇੱਕ ਸੁਰੱਖਿਅਤ, ਸਤਿਕਾਰਯੋਗ ਅਤੇ ਖੁੱਲ੍ਹੇ ਦਿਮਾਗ ਵਾਲੀ ਜਗ੍ਹਾ
     ਵਿੱਚ ਕਦਮ ਰੱਖੋ। ਭਾਵੇਂ ਤੁਸੀਂ ਨਵੇਂ ਤਜ਼ਰਬਿਆਂ ਦੀ ਪੜਚੋਲ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ, ਸਮਾਨ ਸੋਚ ਵਾਲੇ ਲੋਕਾਂ ਨਾਲ ਜੁੜਨਾ ਚਾਹੁੰਦੇ ਹੋ, ਜਾਂ 
     ਆਪਣੀ ਜੀਵਨ ਸ਼ੈਲੀ ਲਈ ਸੰਪੂਰਨ ਮੇਲ ਲੱਭਣਾ ਚਾਹੁੰਦੇ ਹੋ, ਸਾਡੀ ਐਪ ਇਸਨੂੰ ਆਸਾਨ ਬਣਾਉਂਦੀ ਹੈ। ਪ੍ਰਮਾਣਿਤ ਉਪਭੋਗਤਾਵਾਂ ਨਾਲ 
     ਅਸਲ ਕਨੈਕਸ਼ਨਾਂ ਦੀ ਖੋਜ ਕਰੋ, ਸੁਰੱਖਿਅਤ ਢੰਗ ਨਾਲ ਚੈਟ ਕਰੋ, ਅਤੇ ਸਥਾਨਕ ਸਮਾਗਮਾਂ ਜਾਂ ਨਿੱਜੀ ਸਮੂਹਾਂ ਵਿੱਚ ਸ਼ਾਮਲ ਹੋਵੋ। 
     ਸਮਾਰਟ ਮੈਚਿੰਗ, ਵਿਵੇਕ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ, ਅਤੇ ਇੱਕ ਨਿਰਣੇ-ਮੁਕਤ ਭਾਈਚਾਰੇ ਦੇ ਨਾਲ, ਤੁਹਾਡਾ ਅਗਲਾ ਦਿਲਚਸਪ ਕਨੈਕਸ਼ਨ ਸਿਰਫ਼ 
     ਇੱਕ ਸਵਾਈਪ ਦੂਰ ਹੈ।`
  },
  {
    src: swingAdmin,
    link:"https://admin.opaqueswingers.com/admin-login",
    name:"The Ultimate Swinger Dating App Admin",
    type:"web",
    figma:"https://drive.google.com/file/d/1XMdd30aiIAd4TT8xq0KK97TkvkQ0NKpc/view?usp=sharing",
    isSecure:true,
    description:`ਸਾਹਸੀ ਜੋੜਿਆਂ ਅਤੇ ਸਿੰਗਲਜ਼ ਲਈ ਤਿਆਰ ਕੀਤੀ ਗਈ ਇੱਕ ਸੁਰੱਖਿਅਤ, ਸਤਿਕਾਰਯੋਗ ਅਤੇ ਖੁੱਲ੍ਹੇ ਦਿਮਾਗ ਵਾਲੀ ਜਗ੍ਹਾ
    ਵਿੱਚ ਕਦਮ ਰੱਖੋ। ਭਾਵੇਂ ਤੁਸੀਂ ਨਵੇਂ ਤਜ਼ਰਬਿਆਂ ਦੀ ਪੜਚੋਲ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ, ਸਮਾਨ ਸੋਚ ਵਾਲੇ ਲੋਕਾਂ ਨਾਲ ਜੁੜਨਾ ਚਾਹੁੰਦੇ ਹੋ, ਜਾਂ 
    ਆਪਣੀ ਜੀਵਨ ਸ਼ੈਲੀ ਲਈ ਸੰਪੂਰਨ ਮੇਲ ਲੱਭਣਾ ਚਾਹੁੰਦੇ ਹੋ, ਸਾਡੀ ਐਪ ਇਸਨੂੰ ਆਸਾਨ ਬਣਾਉਂਦੀ ਹੈ। ਪ੍ਰਮਾਣਿਤ ਉਪਭੋਗਤਾਵਾਂ ਨਾਲ 
    ਅਸਲ ਕਨੈਕਸ਼ਨਾਂ ਦੀ ਖੋਜ ਕਰੋ, ਸੁਰੱਖਿਅਤ ਢੰਗ ਨਾਲ ਚੈਟ ਕਰੋ, ਅਤੇ ਸਥਾਨਕ ਸਮਾਗਮਾਂ ਜਾਂ ਨਿੱਜੀ ਸਮੂਹਾਂ ਵਿੱਚ ਸ਼ਾਮਲ ਹੋਵੋ। 
    ਸਮਾਰਟ ਮੈਚਿੰਗ, ਵਿਵੇਕ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ, ਅਤੇ ਇੱਕ ਨਿਰਣੇ-ਮੁਕਤ ਭਾਈਚਾਰੇ ਦੇ ਨਾਲ, ਤੁਹਾਡਾ ਅਗਲਾ ਦਿਲਚਸਪ ਕਨੈਕਸ਼ਨ ਸਿਰਫ਼ 
    ਇੱਕ ਸਵਾਈਪ ਦੂਰ ਹੈ।`
  },
  {
    src: GaAdmin,
    link:"https://ga-staging.castledigital.com.au/",
    name:"Grief Australia",
    type:"web",
    figma:null,
    isSecure:true,
    description:`ਗ੍ਰੀਫ ਆਸਟ੍ਰੇਲੀਆ ਐਡਮਿਨ ਪੈਨਲ ਇੱਕ ਵਿਆਪਕ ਬੈਕਐਂਡ ਪ੍ਰਬੰਧਨ ਪ੍ਰਣਾਲੀ ਹੈ ਜੋ ਗ੍ਰੀਫ ਆਸਟ੍ਰੇਲੀਆ ਦੇ ਕਾਰਜਾਂ ਦਾ 
    ਸਮਰਥਨ ਕਰਨ ਲਈ ਵਿਕਸਤ ਕੀਤੀ ਗਈ ਹੈ, ਜੋ ਕਿ ਇੱਕ ਪ੍ਰਮੁੱਖ ਸੰਸਥਾ ਹੈ ਜੋ ਸੋਗ ਅਤੇ ਸੋਗ ਸਹਾਇਤਾ ਸੇਵਾਵਾਂ ਪ੍ਰਦਾਨ ਕਰਦੀ ਹੈ। 
    ਪਲੇਟਫਾਰਮ ਪ੍ਰਸ਼ਾਸਕਾਂ ਨੂੰ ਇੱਕ ਸੁਰੱਖਿਅਤ, ਉਪਭੋਗਤਾ-ਅਨੁਕੂਲ ਇੰਟਰਫੇਸ ਰਾਹੀਂ ਉਪਭੋਗਤਾਵਾਂ, ਸਰੋਤਾਂ, ਪ੍ਰੋਗਰਾਮਾਂ, ਸਮਾਗਮਾਂ ਅਤੇ 
    ਸਮੱਗਰੀ ਦਾ ਕੁਸ਼ਲਤਾ ਨਾਲ ਪ੍ਰਬੰਧਨ ਕਰਨ ਦੇ ਯੋਗ ਬਣਾਉਂਦਾ ਹੈ। ਸਕੇਲੇਬਿਲਟੀ ਅਤੇ ਵਰਤੋਂ ਵਿੱਚ ਆਸਾਨੀ ਨੂੰ ਧਿਆਨ ਵਿੱਚ ਰੱਖਦੇ 
    ਹੋਏ ਤਿਆਰ ਕੀਤਾ ਗਿਆ, ਐਡਮਿਨ ਪੈਨਲ ਸੰਗਠਨ ਲਈ ਰੋਜ਼ਾਨਾ ਦੇ ਸੁਚਾਰੂ ਕਾਰਜਾਂ ਨੂੰ ਯਕੀਨੀ ਬਣਾਉਣ ਲਈ ਸਮੱਗਰੀ ਅਪਡੇਟਾਂ, 
    ਉਪਭੋਗਤਾ ਅਨੁਮਤੀਆਂ, ਡੇਟਾ ਟਰੈਕਿੰਗ ਅਤੇ ਸਿਸਟਮ ਸੰਰਚਨਾਵਾਂ ਨੂੰ ਸੁਚਾਰੂ ਬਣਾਉਂਦਾ ਹੈ।`
  },
  {
    src: WhatKeyAdmin,
    link:"https://app.whatkey.io/",
    name:"What Key",
    type:"web",
    figma:null,
    isSecure:true,
    description:`WhatKey ਐਡਮਿਨ ਪੈਨਲ WhatKey ਕੁੰਜੀ ਪ੍ਰਬੰਧਨ ਪਲੇਟਫਾਰਮ ਦੇ ਕਾਰਜਾਂ ਦਾ ਪ੍ਰਬੰਧਨ ਕਰਨ ਲਈ ਇੱਕ ਕੇਂਦਰੀਕ੍ਰਿਤ 
    ਬੈਕਐਂਡ ਸਿਸਟਮ ਹੈ। ਪ੍ਰਸ਼ਾਸਕਾਂ ਲਈ ਤਿਆਰ ਕੀਤਾ ਗਿਆ, ਇਹ ਪੈਨਲ ਡਿਜੀਟਲ ਕੁੰਜੀ ਅਸਾਈਨਮੈਂਟਾਂ, ਉਪਭੋਗਤਾ ਪਹੁੰਚ ਪੱਧਰਾਂ, ਆਡਿਟ 
    ਟ੍ਰੇਲ ਅਤੇ ਸੰਪਤੀ ਟਰੈਕਿੰਗ 'ਤੇ ਸਹਿਜ ਨਿਯੰਤਰਣ ਦੀ ਆਗਿਆ ਦਿੰਦਾ ਹੈ। ਇੱਕ ਸਾਫ਼ UI ਅਤੇ ਮਜ਼ਬੂਤ ​​ਕਾਰਜਸ਼ੀਲਤਾ ਦੇ ਨਾਲ, ਇਹ 
    ਉਪਭੋਗਤਾਵਾਂ ਦੀ ਨਿਗਰਾਨੀ ਕਰਨ, ਭੌਤਿਕ ਅਤੇ ਡਿਜੀਟਲ ਕੁੰਜੀਆਂ ਦਾ ਪ੍ਰਬੰਧਨ ਕਰਨ, ਅਤੇ ਵਰਤੋਂ ਇਤਿਹਾਸ ਦੀ ਨਿਗਰਾਨੀ ਕਰਨ ਦੀ 
    ਪ੍ਰਕਿਰਿਆ ਨੂੰ ਸਰਲ ਬਣਾਉਂਦਾ ਹੈ - ਸੰਗਠਨਾਂ ਲਈ ਸੁਰੱਖਿਅਤ ਅਤੇ ਕੁਸ਼ਲ ਕੁੰਜੀ ਵੰਡ ਨੂੰ ਯਕੀਨੀ ਬਣਾਉਂਦਾ ਹੈ।`
  },
  {
    src: ikidzschool,
    link: "https://app.ikidzschools.com/",
    name: "ਆਈਕਿਡਜ਼ ਸਕੂਲ",
    type: "web",
    figma: null,
    isSecure: true,
    description: `IkidzSchool ਐਡਮਿਨ ਪੈਨਲ ਇੱਕ ਸ਼ਕਤੀਸ਼ਾਲੀ ਅਤੇ ਉਪਭੋਗਤਾ-ਅਨੁਕੂਲ ਬੈਕਐਂਡ ਪ੍ਰਬੰਧਨ ਪ੍ਰਣਾਲੀ ਹੈ ਜੋ ਵਿਸ਼ੇਸ਼ ਤੌਰ 'ਤੇ 
    ਪ੍ਰੀਸਕੂਲ ਅਤੇ ਡੇਅਕੇਅਰ ਸੈਂਟਰਾਂ ਲਈ ਤਿਆਰ ਕੀਤੀ ਗਈ ਹੈ। ਇਹ ਸਕੂਲ ਪ੍ਰਸ਼ਾਸਕਾਂ ਅਤੇ ਸਿੱਖਿਅਕਾਂ ਨੂੰ ਇੱਕ ਕੇਂਦਰੀਕ੍ਰਿਤ ਪਲੇਟਫਾਰਮ ਪ੍ਰਦਾਨ ਕਰਦਾ
     ਹੈ ਤਾਂ ਜੋ ਕਈ ਕੇਂਦਰਾਂ ਵਿੱਚ ਰੋਜ਼ਾਨਾ ਕਾਰਜਾਂ ਨੂੰ ਆਸਾਨੀ ਅਤੇ ਸ਼ੁੱਧਤਾ ਨਾਲ ਪ੍ਰਬੰਧਿਤ ਕੀਤਾ ਜਾ ਸਕੇ। ਸਹੀ ਹਾਜ਼ਰੀ ਰਿਕਾਰਡ ਰੱਖਣ, ਕਲਾਸਾਂ ਦਾ 
     ਸਮਾਂ ਤਹਿ ਕਰਨ ਅਤੇ ਪੌਸ਼ਟਿਕ ਭੋਜਨ ਮੀਨੂ ਦੀ ਯੋਜਨਾ ਬਣਾਉਣ ਤੋਂ ਲੈ ਕੇ ਮਾਪਿਆਂ ਨਾਲ ਅਸਲ-ਸਮੇਂ ਦੇ ਸੰਚਾਰ ਨੂੰ ਸਮਰੱਥ ਬਣਾਉਣ ਅਤੇ ਬੱਚਿਆਂ 
     ਦੀ ਸੁਰੱਖਿਆ ਲਈ ਲਾਈਵ ਸੀਸੀਟੀਵੀ ਨਿਗਰਾਨੀ ਤੱਕ - ਸਭ ਕੁਝ ਇੱਕ ਅਨੁਭਵੀ ਡੈਸ਼ਬੋਰਡ ਵਿੱਚ ਸਹਿਜੇ ਹੀ ਏਕੀਕ੍ਰਿਤ ਹੈ। ਪੈਨਲ ਸ਼ਹਿਰ, ਰਾਜ, 
     ਸਟਾਫ ਵੇਰਵਿਆਂ ਅਤੇ ਇੰਚਾਰਜ ਭੂਮਿਕਾਵਾਂ ਵਰਗੇ ਜ਼ਰੂਰੀ ਡੇਟਾ ਤੱਕ ਤੇਜ਼ ਪਹੁੰਚ ਦੀ ਪੇਸ਼ਕਸ਼ ਕਰਕੇ ਕੁਸ਼ਲ ਕੇਂਦਰ-ਵਾਰ ਪ੍ਰਬੰਧਨ ਦੀ ਆਗਿਆ ਦਿੰਦਾ ਹੈ।
      ਇਹ ਗਾਹਕੀ ਟਰੈਕਿੰਗ ਅਤੇ ਕਾਰੋਬਾਰੀ ਸੂਝ ਦਾ ਵੀ ਸਮਰਥਨ ਕਰਦਾ ਹੈ, ਪ੍ਰਸ਼ਾਸਕਾਂ ਨੂੰ ਹਰੇਕ ਕੇਂਦਰ ਦੇ ਪ੍ਰਦਰਸ਼ਨ ਅਤੇ ਕਾਰਜਾਂ ਦਾ ਸਪਸ਼ਟ ਦ੍ਰਿਸ਼ਟੀਕੋਣ
     ਦਿੰਦਾ ਹੈ। ਸਕੇਲ ਲਈ ਬਣਾਇਆ ਗਿਆ, IkidzSchool ਐਡਮਿਨ ਪੈਨਲ ਡੇਟਾ ਸੁਰੱਖਿਆ, ਪਹੁੰਚ ਨਿਯੰਤਰਣ ਅਤੇ ਸੰਚਾਲਨ ਪਾਰਦਰਸ਼ਤਾ ਨੂੰ 
     ਯਕੀਨੀ ਬਣਾਉਂਦਾ ਹੈ - ਸਿੱਖਿਅਕਾਂ ਨੂੰ ਸ਼ੁਰੂਆਤੀ ਬਚਪਨ ਦੇ ਵਿਕਾਸ 'ਤੇ ਵਧੇਰੇ ਧਿਆਨ ਕੇਂਦਰਿਤ ਕਰਨ ਲਈ ਸ਼ਕਤੀ ਪ੍ਰਦਾਨ ਕਰਦਾ ਹੈ ਜਦੋਂ ਕਿ 
     ਤਕਨਾਲੋਜੀ ਬਾਕੀ ਨੂੰ ਸੰਭਾਲਦੀ ਹੈ। ਇਸਦੇ ਸਾਫ਼ ਡਿਜ਼ਾਈਨ ਅਤੇ ਮਜ਼ਬੂਤ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ ਦੇ ਨਾਲ, ਇਹ ਸਕੂਲ ਪ੍ਰਸ਼ਾਸਨ ਨੂੰ ਸਰਲ ਬਣਾਉਂਦਾ ਹੈ 
     ਅਤੇ ਸਟਾਫ ਅਤੇ ਮਾਪਿਆਂ ਦੋਵਾਂ ਨਾਲ ਸ਼ਮੂਲੀਅਤ ਨੂੰ ਵਧਾਉਂਦਾ ਹੈ, ਇਸਨੂੰ ਆਧੁਨਿਕ ਪ੍ਰੀਸਕੂਲ ਪ੍ਰਬੰਧਨ ਲਈ ਇੱਕ ਲਾਜ਼ਮੀ ਸਾਧਨ ਬਣਾਉਂਦਾ ਹੈ। `,
  },
  {
    src: hcbaadvocate,
    link: "https://hcbasp.anixinventive.com/",
    name: "ਕਾਨੂੰਨੀ ਪੇਸ਼ੇਵਰਾਂ (ਐਡਵੋਕੇਟ) ਨੂੰ ਸਸ਼ਕਤ ਬਣਾਉਣਾ",
    type: "web",
    figma: null,
    isSecure: true,
    description: `ਪੰਜਾਬ ਅਤੇ ਹਰਿਆਣਾ ਹਾਈ ਕੋਰਟ ਬਾਰ ਐਸੋਸੀਏਸ਼ਨ ਇੱਕ ਵਿਲੱਖਣ ਕਾਨੂੰਨੀ ਸੰਸਥਾ ਵਜੋਂ ਖੜ੍ਹੀ ਹੈ, ਜੋ ਪੰਜਾਬ ਅਤੇ ਹਰਿਆਣਾ ਹਾਈ ਕੋਰਟ 
    ਵਿੱਚ ਅਭਿਆਸ ਕਰਨ ਵਾਲੇ ਵਕੀਲਾਂ ਦੀ ਨੁਮਾਇੰਦਗੀ ਕਰਦੀ ਹੈ। ਨਿਆਂ, ਇਮਾਨਦਾਰੀ ਅਤੇ ਕਾਨੂੰਨੀ ਉੱਤਮਤਾ ਪ੍ਰਤੀ ਦ੍ਰਿੜ ਵਚਨਬੱਧਤਾ ਦੇ ਨਾਲ, 
    ਐਸੋਸੀਏਸ਼ਨ ਕਾਨੂੰਨੀ ਭਾਈਚਾਰੇ ਅਤੇ ਨਿਆਂਪਾਲਿਕਾ ਵਿਚਕਾਰ ਇੱਕ ਪੁਲ ਵਜੋਂ ਕੰਮ ਕਰਦੀ ਹੈ, ਜੋ ਕਿ ਪੂਰੇ ਖੇਤਰ ਵਿੱਚ ਨਿਆਂ ਦੇ ਪ੍ਰਭਾਵਸ਼ਾਲੀ 
    ਪ੍ਰਸ਼ਾਸਨ ਨੂੰ ਯਕੀਨੀ ਬਣਾਉਂਦੀ ਹੈ। ਪਾਰਦਰਸ਼ਤਾ, ਕੁਸ਼ਲਤਾ ਅਤੇ ਮੈਂਬਰਾਂ ਦੀ ਸਹੂਲਤ ਨੂੰ ਵਧਾਉਣ ਲਈ, ਅਸੀਂ ਮਾਣ ਨਾਲ ਐਡਵੋਕੇਟ ਡਿਜੀਟਲ
     ਪੈਨਲ ਪੇਸ਼ ਕਰਦੇ ਹਾਂ, ਜੋ ਕਿ ਕਾਨੂੰਨੀ ਪੇਸ਼ੇਵਰਾਂ ਦੀਆਂ ਆਧੁਨਿਕ ਜ਼ਰੂਰਤਾਂ ਨੂੰ ਪੂਰਾ ਕਰਨ ਲਈ ਤਿਆਰ ਕੀਤਾ ਗਿਆ ਇੱਕ ਵਿਆਪਕ
     ਵੈੱਬ-ਅਧਾਰਤ ਪਲੇਟਫਾਰਮ ਹੈ।`,
  },
  {
    src: reliefhub,
    link: "https://www.reliefhub.app/login",
    name: "ReliefHub.",
    type: "web",
    figma: "https://www.figma.com/design/XBYc0SkH3YI41rGIRZjd0d/AR-Copy?node-id=334-17637&p=f",
    isSecure: true,
    description: `ReliefHub ਇੱਕ ਪੂਰੀ ਤਰ੍ਹਾਂ ਵਿਕਸਿਤ ਆਫ਼ਤ ਰਾਹਤ ਪ੍ਰਬੰਧਨ ਸਿਸਟਮ ਹੈ, ਜੋ ਸੰਸਥਾਵਾਂ, ਸੇਵਾਦਾਰਾਂ ਅਤੇ ਪ੍ਰਭਾਵਿਤ ਘਰ-ਮਾਲਕਾਂ ਵਿਚਕਾਰ ਸਮਨ੍ਵਯਤਾ ਨੂੰ ਆਸਾਨ ਅਤੇ ਪ੍ਰਭਾਵਸ਼ਾਲੀ ਬਣਾਉਣ ਲਈ ਤਿਆਰ ਕੀਤਾ ਗਿਆ ਹੈ।
    ਇਹ ਇੱਕ ਕੇਂਦਰੀਕ੍ਰਿਤ ਪਲੇਟਫਾਰਮ ਪ੍ਰਦਾਨ ਕਰਦਾ ਹੈ ਜੋ ਰਾਹਤ ਕਾਰਜਾਂ ਨੂੰ ਕੁਸ਼ਲਤਾਪੂਰਵਕ ਪ੍ਰਬੰਧਿਤ ਕਰਨ ਵਿੱਚ ਮਦਦ ਕਰਦਾ ਹੈ — ਕੰਮ ਦੇ ਆਰਡਰਾਂ ਨੂੰ ਟ੍ਰੈਕ ਕਰਨ ਤੋਂ ਲੈ ਕੇ ਟੀਮਾਂ ਨਾਲ ਸੰਚਾਰ ਕਰਨ ਅਤੇ ਰੀਅਲ-ਟਾਈਮ ਰਿਪੋਰਟਾਂ ਤਿਆਰ ਕਰਨ ਤੱਕ।
    ਇਸ ਸਿਸਟਮ ਵਿੱਚ ਛੇ ਵੱਖ-ਵੱਖ ਕਿਸਮ ਦੇ ਲੌਗਇਨ ਹਨ, ਜੋ ਹਰ ਉਪਭੋਗਤਾ ਦੀ ਭੂਮਿਕਾ ਅਤੇ ਅਧਿਕਾਰਾਂ ਅਨੁਸਾਰ ਤਿਆਰ ਕੀਤੇ ਗਏ ਹਨ, ਤਾਂ ਜੋ ਜਾਣਕਾਰੀ ਸੁਰੱਖਿਅਤ ਰਹੇ ਅਤੇ ਹਰ ਉਪਭੋਗਤਾ ਨੂੰ ਉਸਦੀ ਭੂਮਿਕਾ ਅਨੁਸਾਰ ਪਹੁੰਚ ਅਤੇ ਸੁਵਿਧਾਵਾਂ ਮਿਲ ਸਕਣ।`,
  },
  // apps
  {
    src: ga,
    link:"",
    name:"Grief Australia",
    type:"apps",
    figma:"https://www.figma.com/design/ZMfNWLaEfEgje0XfOsu8Zb/Grief-Australia---Mobile-app?node-id=1729-6926&p=f",
    adminFigma:"https://www.figma.com/design/ZMfNWLaEfEgje0XfOsu8Zb/Grief-Australia---Mobile-app?node-id=1047-6597&p=f",
    description:`ਗ੍ਰੀਫ ਆਸਟ੍ਰੇਲੀਆ ਇੱਕ ਅਜਿਹੀ ਸੰਸਥਾ ਹੈ ਜੋ ਸੋਗ ਅਤੇ ਨੁਕਸਾਨ ਦਾ ਸਾਹਮਣਾ ਕਰ ਰਹੇ 
    ਵਿਅਕਤੀਆਂ ਅਤੇ ਪਰਿਵਾਰਾਂ ਨੂੰ ਸਹਾਇਤਾ, ਸਿੱਖਿਆ ਅਤੇ ਸਰੋਤ ਪ੍ਰਦਾਨ ਕਰਦੀ ਹੈ। ਉਹ ਲੋਕਾਂ ਨੂੰ ਸੋਗ ਵਿੱਚੋਂ 
    ਲੰਘਣ ਵਿੱਚ ਮਦਦ ਕਰਨ ਲਈ ਸਲਾਹ ਸੇਵਾਵਾਂ, ਸਿਖਲਾਈ ਪ੍ਰੋਗਰਾਮ ਅਤੇ ਖੋਜ ਪਹਿਲਕਦਮੀਆਂ ਦੀ ਪੇਸ਼ਕਸ਼ 
    ਕਰਦੇ ਹਨ। ਇਹ ਸੰਸਥਾ ਹਮਦਰਦੀ ਵਾਲੀ ਦੇਖਭਾਲ, ਸਬੂਤ-ਅਧਾਰਤ ਪਹੁੰਚਾਂ, ਅਤੇ ਕਿਸੇ ਅਜ਼ੀਜ਼ ਦੀ ਮੌਤ 
    ਨਾਲ ਜੂਝ ਰਹੇ ਲੋਕਾਂ ਦੀ ਸਹਾਇਤਾ ਲਈ ਭਾਈਚਾਰਕ ਸਹਾਇਤਾ 'ਤੇ ਕੇਂਦ੍ਰਤ ਕਰਦੀ ਹੈ।`
  },
  {
    src: lovelife,
    link:"https://play.google.com/store/apps/details?id=com.sa.lovelife&pli=1",
    name:"Love Life",
    type:"apps",
    figma:"https://drive.google.com/drive/folders/1Ag8DUABP0OKnpaoQEUTtO9o6dwmDV-BK",
    description:`"ਲਵ ਲਾਈਫ" ਇੱਕ ਰੋਮਾਂਟਿਕ ਕਾਮੇਡੀ-ਡਰਾਮਾ ਸੰਗ੍ਰਹਿ ਲੜੀ ਹੈ ਜਿਸਦਾ ਪ੍ਰੀਮੀਅਰ HBO 
    Max 'ਤੇ ਹੋਇਆ ਸੀ। ਇਹ ਵੱਖ-ਵੱਖ ਪਾਤਰਾਂ ਦੇ ਸਫ਼ਰ ਦੀ ਪਾਲਣਾ ਕਰਦਾ ਹੈ ਜਦੋਂ ਉਹ ਸਮੇਂ ਦੇ ਨਾਲ 
    ਪਿਆਰ, ਰਿਸ਼ਤਿਆਂ ਅਤੇ ਨਿੱਜੀ ਵਿਕਾਸ ਨੂੰ ਨੈਵੀਗੇਟ ਕਰਦੇ ਹਨ। ਹਰ ਸੀਜ਼ਨ ਇੱਕ ਨਵੇਂ ਨਾਇਕ 'ਤੇ ਕੇਂਦ੍ਰਤ 
    ਕਰਦਾ ਹੈ, ਪਹਿਲੇ ਪਿਆਰ ਤੋਂ ਲੈ ਕੇ ਸਥਾਈ ਸਬੰਧਾਂ ਤੱਕ ਰੋਮਾਂਸ ਦੇ ਨਾਲ ਉਨ੍ਹਾਂ ਦੇ ਅਨੁਭਵਾਂ ਦੀ ਪੜਚੋਲ 
    ਕਰਦਾ ਹੈ। ਇਹ ਸ਼ੋਅ ਹਾਸੇ-ਮਜ਼ਾਕ ਅਤੇ ਭਾਵਨਾਤਮਕ ਡੂੰਘਾਈ ਨਾਲ ਆਧੁਨਿਕ ਰਿਸ਼ਤਿਆਂ ਦੇ ਉਤਰਾਅ-ਚੜ੍ਹਾਅ 
    ਨੂੰ ਉਜਾਗਰ ਕਰਦਾ ਹੈ।`
  },
  {
    src: sportsjournal,
    link:"",
    name:"Sports Journal",
    type:"apps",
    figma:"https://www.figma.com/design/MmjGbzMsZGEx09LmZjJoZI/Sport-Journal?node-id=283-463&p=f",
    adminFigma:"https://www.figma.com/design/MmjGbzMsZGEx09LmZjJoZI/Sport-Journal?node-id=0-1&p=f",
    description:`ਸਪੋਰਟਸ ਜਰਨਲ ਇੱਕ ਢਾਂਚਾਗਤ ਰਿਕਾਰਡ ਹੈ ਜੋ ਵੱਖ-ਵੱਖ ਖੇਡ ਸਮਾਗਮਾਂ 'ਤੇ ਉਤਸ਼ਾਹ, 
    ਵਿਸ਼ਲੇਸ਼ਣ ਅਤੇ ਨਿੱਜੀ ਪ੍ਰਤੀਬਿੰਬਾਂ ਨੂੰ ਕੈਪਚਰ ਕਰਦਾ ਹੈ। ਇਹ ਐਥਲੀਟਾਂ, ਪ੍ਰਸ਼ੰਸਕਾਂ ਅਤੇ ਵਿਸ਼ਲੇਸ਼ਕਾਂ ਲਈ ਖੇਡ 
    ਜਗਤ ਵਿੱਚ ਖੇਡ ਦੀਆਂ ਮੁੱਖ ਗੱਲਾਂ, ਖਿਡਾਰੀਆਂ ਦੇ ਪ੍ਰਦਰਸ਼ਨ, ਰਣਨੀਤੀਆਂ ਅਤੇ ਰੁਝਾਨਾਂ ਨੂੰ ਦਸਤਾਵੇਜ਼ੀ ਰੂਪ 
    ਦੇਣ ਲਈ ਇੱਕ ਪਲੇਟਫਾਰਮ ਵਜੋਂ ਕੰਮ ਕਰਦਾ ਹੈ।`
  },
  {
    src: skin_care,
    link:"",
    name:"Skin Care",
    type:"apps",
    figma:"https://www.figma.com/design/YOllk4yxV6hCJsLqBSA306/UpSkin-Project--Engineer-Preview-?node-id=13-742&p=f",
    description:`ਆਲ-ਇਨ-ਵਨ ਐਪ ਤੁਹਾਨੂੰ ਆਸਾਨੀ ਨਾਲ ਸਿਹਤਮੰਦ, ਚਮਕਦਾਰ ਚਮੜੀ ਪ੍ਰਾਪਤ ਕਰਨ 
    ਵਿੱਚ ਮਦਦ ਕਰਨ ਲਈ ਤਿਆਰ ਕੀਤਾ ਗਿਆ ਹੈ। ਹੋਮ ਸਕ੍ਰੀਨ 'ਤੇ ਤੁਹਾਡੀਆਂ ਜ਼ਰੂਰਤਾਂ ਦੇ ਅਨੁਸਾਰ ਤਿਆਰ 
    ਕੀਤੇ ਗਏ ਸਕਿਨਕੇਅਰ ਉਤਪਾਦਾਂ ਦੀ ਇੱਕ ਕਿਉਰੇਟਿਡ ਸੂਚੀ ਦੀ ਪੜਚੋਲ ਕਰੋ, ਸਮੱਗਰੀ, ਸਮੀਖਿਆਵਾਂ ਅਤੇ 
    ਮਾਹਰ ਸਿਫ਼ਾਰਸ਼ਾਂ ਨਾਲ ਭਰਪੂਰ। ਵਿਅਕਤੀਗਤ ਸਲਾਹ, ਰੁਟੀਨ ਸੁਝਾਵਾਂ ਅਤੇ ਆਪਣੇ ਸਕਿਨਕੇਅਰ ਸਵਾਲਾਂ ਦੇ 
    ਤੁਰੰਤ ਜਵਾਬਾਂ ਲਈ ਸਾਡੇ ਬੁੱਧੀਮਾਨ AI-ਸੰਚਾਲਿਤ ਸਕਿਨ ਹੈਲਪਰ ਨਾਲ ਗੱਲਬਾਤ ਕਰੋ। ਖਰੀਦਦਾਰੀ ਕਰਨ ਤੋਂ 
    ਪਹਿਲਾਂ ਵਿਸਤ੍ਰਿਤ ਉਤਪਾਦ ਜਾਣਕਾਰੀ, ਸੁਰੱਖਿਆ ਰੇਟਿੰਗਾਂ ਅਤੇ ਉਪਭੋਗਤਾ ਸਮੀਖਿਆਵਾਂ ਨੂੰ ਜਲਦੀ ਖੋਜਣ ਲਈ 
    ਬਾਰਕੋਡ ਸਕੈਨਰ ਦੀ ਵਰਤੋਂ ਕਰੋ। ਅੰਤ ਵਿੱਚ, ਸਾਡੇ ਕਮਿਊਨਿਟੀ ਸਪੇਸ ਵਿੱਚ ਸਮਾਨ ਸੋਚ ਵਾਲੇ ਵਿਅਕਤੀਆਂ 
    ਨਾਲ ਜੁੜੋ, ਜਿੱਥੇ ਤੁਸੀਂ ਅਨੁਭਵ ਸਾਂਝੇ ਕਰ ਸਕਦੇ ਹੋ, ਸੁਝਾਅ ਪ੍ਰਾਪਤ ਕਰ ਸਕਦੇ ਹੋ, ਅਤੇ ਆਪਣੀ ਸਕਿਨਕੇਅਰ 
      ਯਾਤਰਾ ਲਈ ਪ੍ਰੇਰਿਤ ਰਹਿ ਸਕਦੇ ਹੋ।`
  },
  {
    src: ikidz_smart_app,
    link: "https://play.google.com/store/apps/details?id=com.chouhan07.ikidz&pcampaignid=web_share",
    name: "ਆਈਕਿਡਜ਼ ਸਮਾਰਟ",
    type: "apps",
    figma:null,
    description: `ਆਈਕਿਡਜ਼ਸਕੂਲ ਪੇਰੈਂਟ ਐਪ ਇੱਕ ਸਮਰਪਿਤ ਪਲੇਟਫਾਰਮ ਹੈ ਜੋ ਮਾਪਿਆਂ ਨੂੰ ਆਪਣੇ ਬੱਚੇ ਦੇ ਪ੍ਰੀਸਕੂਲ ਯਾਤਰਾ ਨਾਲ ਸਰਗਰਮੀ ਨਾਲ
     ਜੁੜੇ ਰੱਖਣ ਲਈ ਤਿਆਰ ਕੀਤਾ ਗਿਆ ਹੈ। ਸੁਰੱਖਿਅਤ ਲੌਗਇਨ ਪਹੁੰਚ ਦੇ ਨਾਲ, ਮਾਪੇ ਆਪਣੇ ਬੱਚੇ ਦੀ ਰੋਜ਼ਾਨਾ ਮੌਜੂਦਗੀ ਬਾਰੇ ਸੂਚਿਤ ਰਹਿਣ ਲਈ 
     ਆਸਾਨੀ ਨਾਲ ਰੀਅਲ-ਟਾਈਮ ਹਾਜ਼ਰੀ ਰਿਕਾਰਡ ਦੇਖ ਸਕਦੇ ਹਨ। ਐਪ ਵਿੱਚ ਏਕੀਕ੍ਰਿਤ ਲਾਈਵ ਸੀਸੀਟੀਵੀ ਸਟ੍ਰੀਮਿੰਗ ਵੀ ਸ਼ਾਮਲ ਹੈ, ਜਿਸ ਨਾਲ 
     ਮਾਪਿਆਂ ਨੂੰ ਕਲਾਸ ਅਤੇ ਗਤੀਵਿਧੀ ਦੇ ਸਮੇਂ ਦੌਰਾਨ ਆਪਣੇ ਛੋਟੇ ਬੱਚਿਆਂ ਨੂੰ ਦੇਖਣ ਦੀ ਆਗਿਆ ਮਿਲਦੀ ਹੈ - ਮਨ ਦੀ ਸ਼ਾਂਤੀ ਅਤੇ ਪਾਰਦਰਸ਼ਤਾ 
     ਨੂੰ ਯਕੀਨੀ ਬਣਾਇਆ ਜਾਂਦਾ ਹੈ। ਘਰ ਅਤੇ ਸਕੂਲ ਵਿਚਕਾਰ ਸੰਚਾਰ ਪਾੜੇ ਨੂੰ ਪੂਰਾ ਕਰਕੇ, ਐਪ ਵਿਸ਼ਵਾਸ ਅਤੇ ਸ਼ਮੂਲੀਅਤ ਨੂੰ ਉਤਸ਼ਾਹਿਤ ਕਰਦਾ ਹੈ,
      ਮਾਪਿਆਂ ਨੂੰ ਉਨ੍ਹਾਂ ਦੇ ਬੱਚੇ ਦੇ ਸ਼ੁਰੂਆਤੀ ਸਿੱਖਣ ਦੇ ਅਨੁਭਵ ਲਈ ਇੱਕ ਪਹਿਲੀ ਕਤਾਰ ਵਾਲੀ ਸੀਟ ਦਿੰਦਾ ਹੈ। ਸਰਲ, ਸੁਰੱਖਿਅਤ ਅਤੇ ਭਰੋਸੇਮੰਦ — 
      ਆਈਕਿਡਜ਼ਸਕੂਲ ਪੇਰੈਂਟ ਐਪ ਆਧੁਨਿਕ, ਸੂਚਿਤ ਪਾਲਣ-ਪੋਸ਼ਣ ਲਈ ਇੱਕ ਜ਼ਰੂਰੀ ਸਾਧਨ ਹੈ।`,
  },
  {
    src: hcba_app,
    link: "https://play.google.com/store/apps/details?id=com.advocate.hcba",
    name: "ਐੱਚਸੀਬੀਏ-ਸੀਐਚਡੀ",
    type: "apps",
    figma:null,
    description: `ਪੰਜਾਬ ਅਤੇ ਹਰਿਆਣਾ ਹਾਈ ਕੋਰਟ ਬੇਸ ਐਸੋਸੀਏਸ਼ਨ ਚੰਡੀਗੜ੍ਹ ਮੋਬਾਈਲ ਐਪ ਆਪਣੇ ਰਜਿਸਟਰਡ ਉਪਭੋਗਤਾਵਾਂ ਨੂੰ ਆਪਣੇ 
    ਪ੍ਰੋਫਾਈਲਾਂ ਨੂੰ ਔਨਲਾਈਨ ਐਕਸੈਸ ਅਤੇ ਪ੍ਰਬੰਧਨ ਕਰਨ ਦੇ ਯੋਗ ਬਣਾਉਂਦਾ ਹੈ। ਪੰਜਾਬ ਅਤੇ ਹਰਿਆਣਾ ਹਾਈ ਕੋਰਟ ਬੇਸ ਐਸੋਸੀਏਸ਼ਨ ਚੰਡੀਗੜ੍ਹ
     ਮੋਬਾਈਲ ਐਪ ਆਪਣੇ ਰਜਿਸਟਰਡ ਉਪਭੋਗਤਾਵਾਂ ਨੂੰ ਆਪਣੇ ਪ੍ਰੋਫਾਈਲਾਂ ਨੂੰ ਔਨਲਾਈਨ ਐਕਸੈਸ ਅਤੇ ਪ੍ਰਬੰਧਨ ਕਰਨ ਦੇ ਯੋਗ ਬਣਾਉਂਦਾ ਹੈ।
     ਇਹ ਉਪਭੋਗਤਾਵਾਂ ਨੂੰ ਆਪਣੇ ਸਾਥੀ ਵਕੀਲਾਂ ਨੂੰ ਖੋਜਣ, ਭੁਗਤਾਨ ਇਤਿਹਾਸ ਦੇਖਣ ਅਤੇ ਕਾਨੂੰਨੀ ਵੈੱਬਸਾਈਟਾਂ ਦਾ ਤੇਜ਼ੀ ਨਾਲ ਹਵਾਲਾ ਦੇਣ ਦੀ
     ਆਗਿਆ ਦਿੰਦਾ ਹੈ।`,
  },
  {
    src: rewind,
    link: "https://play.google.com/store/apps/details?id=com.ianix.rewind",
    name: "Rewind",
    type: "apps",
    figma:null,
    description: `ਅੰਤਰਾਤਮਾ ਇੱਕ AI-ਚਲਿਤ ਆਤਮ-ਵਿਮਰਸ਼ ਅਤੇ ਮਨ ਦੀ ਸ਼ਾਂਤੀ ਦੇਣ ਵਾਲਾ ਐਪ ਹੈ,
    ਜੋ ਉਪਭੋਗਤਾਵਾਂ ਨੂੰ ਆਪਣੀ ਅੰਦਰੂਨੀ ਆਤਮਾ ਨਾਲ ਜੁੜਨ ਵਿੱਚ ਮਦਦ ਕਰਨ ਲਈ ਬਣਾਇਆ ਗਿਆ ਹੈ।
    ਇਹ ਐਪ ਆਵਾਜ਼ ਅਤੇ ਟੈਕਸਟ ਇੰਟਰਐਕਸ਼ਨ ਰਾਹੀਂ ਕੰਮ ਕਰਦਾ ਹੈ।
    ਇਹ Gemini AI ਦੇ ਜ਼ਰੀਏ ਨੈਚਰਲ ਲੈਂਗਵੇਜ ਪ੍ਰੋਸੈਸਿੰਗ ਅਤੇ ਭਾਵਨਾਤਮਕ ਜਾਗਰੂਕਤਾ ਦੇ ਟੂਲਾਂ ਨੂੰ ਮਿਲਾ ਕੇ
    ਇੱਕ ਸ਼ਾਂਤ, ਨਿੱਜੀ ਅਤੇ ਸੁਖਦ ਅਨੁਭਵ ਪ੍ਰਦਾਨ ਕਰਦਾ ਹੈ।
    ਉਪਭੋਗਤਾ ਐਪ ਵਿੱਚ ਮੌਜੂਦ ਸਪੀਚ ਰਿਕਗਨਿਸ਼ਨ ਫੀਚਰ ਦੀ ਵਰਤੋਂ ਕਰਕੇ ਆਪਣੇ ਵਿਚਾਰ ਬਿਆਨ ਕਰ ਸਕਦੇ ਹਨ।
    AI (ਅੰਤਰਾਤਮਾ) ਧਿਆਨ ਨਾਲ ਸੁਣਦਾ ਹੈ, ਸਮਝਦਾ ਹੈ, ਅਤੇ ਸਮਵੇਦਨਸ਼ੀਲ ਤਰੀਕੇ ਨਾਲ ਜਵਾਬ ਦਿੰਦਾ ਹੈ —
    ਇਸ ਤਰ੍ਹਾਂ ਇਹ ਇੱਕ ਸੁਰੱਖਿਅਤ ਡਿਜ਼ਿਟਲ ਥਾਂ ਬਣਾਉਂਦਾ ਹੈ ਜਿੱਥੇ ਵਿਅਕਤੀ ਆਪਣੀਆਂ ਭਾਵਨਾਵਾਂ ਖੁੱਲ੍ਹ ਕੇ ਪ੍ਰਗਟ ਕਰ ਸਕਦਾ ਹੈ
    ਅਤੇ ਆਪਣੇ ਆਪ ਦੀ ਜਾਗਰੂਕਤਾ ਨੂੰ ਵਿਕਸਿਤ ਕਰ ਸਕਦਾ ਹੈ।`,
  },
]

const education =(
  <>
    <b>ਚੰਡੀਗੜ੍ਹ ਇੰਜੀਨੀਅਰਿੰਗ ਕਾਲਜ ਤੋਂ ਸੂਚਨਾ ਤਕਨਾਲੋਜੀ ਵਿੱਚ ਬੀ.ਟੈਕ ਦੀ</b> ਡਿਗਰੀ ਪ੍ਰਾਪਤ ਕਰਨ ਤੋਂ ਬਾਅਦ , ਮੇਰੇ ਕੋਲ ਸਾਫਟਵੇਅਰ ਵਿਕਾਸ ਅਤੇ ਇੰਜੀਨੀਅਰਿੰਗ ਸਿਧਾਂਤਾਂ ਵਿੱਚ ਇੱਕ ਮਜ਼ਬੂਤ ​​ਨੀਂਹ ਹੈ, ਫੁੱਲ-ਸਟੈਕ ਵੈੱਬ ਵਿਕਾਸ ਅਤੇ ਅਤਿ-ਆਧੁਨਿਕ ਤਕਨਾਲੋਜੀਆਂ ਵਿੱਚ ਵਿਹਾਰਕ ਤਜਰਬਾ ਹੈ।
  </>
)

// Top / sidebar Link
const links = [
  {
    name: "Home",
    route: "/",
  },
  {
    name: "About",
    route: "about",
  },
  {
    name: "Services",
    route: "services",
  },
  {
    name: "Projects",
    route: "projects",
  },
  {
    name: "Contact",
    route: "contact",
  },
];

const Constant = {
  about,detailAbout,
  technologies_tools,projects
  ,education,Profile_Photo,
  heroBg,cloud,cloudDark,
  shortIntro,techStack,
  contactLinks,links,serviceData
};
export default Constant;
